import { computed, reactive, readonly } from 'vue';

// Sidebar state shared by the sidebar and the header's toggle button,
// modelled on the shadcn/ui sidebar used by the Laravel React starter kit:
// - desktop: expanded (256px) or collapsed to an icon rail, remembered
// - below 768px: an off-canvas panel that closes after navigating
// - Ctrl/Cmd + B toggles it
const MOBILE_BREAKPOINT = 768;
const STORAGE_KEY = 'sidebar_state';

function readStored() {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'collapsed';
  } catch {
    return true;
  }
}

const state = reactive({
  open: readStored(),
  openMobile: false,
  width: typeof window === 'undefined' ? 1280 : window.innerWidth,
});

let listening = false;
function listen() {
  if (listening || typeof window === 'undefined') return;
  listening = true;
  window.addEventListener('resize', () => {
    state.width = window.innerWidth;
  });
  window.addEventListener('keydown', (event) => {
    if (event.key.toLowerCase() === 'b' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      toggle();
    }
  });
}

const isMobile = computed(() => state.width < MOBILE_BREAKPOINT);
const collapsed = computed(() => !isMobile.value && !state.open);

function setOpen(value) {
  state.open = value;
  try {
    localStorage.setItem(STORAGE_KEY, value ? 'expanded' : 'collapsed');
  } catch {
    // Private mode etc.: the state just won't be remembered.
  }
}

function setOpenMobile(value) {
  state.openMobile = value;
}

function toggle() {
  if (isMobile.value) setOpenMobile(!state.openMobile);
  else setOpen(!state.open);
}

export function useSidebar() {
  listen();
  return {
    state: readonly(state),
    isMobile,
    collapsed,
    toggle,
    setOpen,
    setOpenMobile,
  };
}
